export const RouteConstant = {
    Banner: 'banner'
  };
  